<template>
  <section class="py-6 px-4 sm:p-6 lg:pb-8">
    <div class="flex flex-col">
      <h2 class="text-lg leading-6 font-medium text-gray-900">
        {{ title }}
      </h2>
      <p v-if="slots.text" class="mt-1 text-sm text-gray-500">
        <slot name="text" />
      </p>
    </div>
    <slot name="form" />
  </section>
</template>

<script setup>
import { useSlots } from 'vue';
const props = defineProps({title: String});
const slots = useSlots();
</script>
